import { Chip } from "@mui/material";
import { useMemo } from "react";

const CircleAvailabilities = ({
    availableCars
}: {
    availableCars: number
}) => {

    const color = useMemo<'default' | 'error' | 'warning' | 'success'>(() => {
        if (availableCars >= 2) {
           return 'success';
        } else if (availableCars === 1) {
            return 'warning';
        } else if (availableCars === 0) {
            return 'error';
        } else {
            return 'default';
        }
    }, [availableCars]);

    return (
        <Chip
            label={availableCars}
            color={color}
        />
    );
};

export default CircleAvailabilities;